import { FormLabel, Grid, TextField } from "@mui/material";
export const ViewAndEditEntity = ({
  handleInputChange,
  index,
  row,
  viewMode,
  validationStatus,
  allocationStatus
}) => {
  //inline style
  const InlineStyle = {
    EntityDivison: {
      width: "230px", height: "32", padding: "0px"
    },
  }
  return (
    <form>
      <Grid container justifyContent={"space-between"}>
        <Grid
          item
          xs={4}
          display={"flex"}
          flexDirection={"column"}
          gap={"5px"}
          mt={"20px"}
        >
          <FormLabel>Currency Code</FormLabel>
          <TextField
            value={row.currency_code}
            onChange={(e) =>
              handleInputChange(index, "currency_code", e.target.value)
            }
            sx={InlineStyle.EntityDivison}
            size="small"
            placeholder="Enter Details Here"
            disabled={viewMode}
          />
          <br />
          {validationStatus[index]?.currency_code && (
            <span style={{ color: "red" }}>
              {validationStatus[index]?.currency_code}
            </span>
          )}
        </Grid>
        <Grid
          item
          xs={6}
          display={"flex"}
          flexDirection={"column"}
          gap={"5px"}
          mt={"20px"}
        >
          <FormLabel>Country and Currency</FormLabel>
          <TextField
            value={row.country_and_currency}
            onChange={(e) =>
              handleInputChange(index, "country_and_currency", e.target.value)
            }
            sx={InlineStyle.EntityDivison}
            size="small"
            placeholder="Enter Details Here"
            disabled={viewMode}
          />
          <br />
          {validationStatus[index]?.country_and_currency && (
            <span style={{ color: "red" }}>
              {validationStatus[index]?.country_and_currency}
            </span>
          )}
        </Grid>
        <Grid
          item
          xs={8}
          display={"flex"}
          flexDirection={"column"}
          gap={"5px"}
          mt={"20px"}
        >
          <FormLabel>Symbol</FormLabel>
          <TextField
            value={row.symbol}
            onChange={(e) =>
              handleInputChange(index, "symbol", e.target.value)
            }
            sx={InlineStyle.EntityDivison}
            size="small"
            placeholder="Enter Details Here"
            disabled={viewMode}
          /><br />
          {validationStatus[index]?.symbol && (
            <span style={{ color: 'red' }}>{validationStatus[index]?.symbol}</span>
          )}
        </Grid>
      </Grid>
    </form>
  );
}